<template>
    <tutorial></tutorial>
</template>

<script>
export default {
    components: {
        History,
        Tutorial: resolve => {
            resolve({
                template: Config.tutorial_template,
                data() {
                    return {
                        gameName: Config.game_name.toLowerCase(),
                        gameNameUpper: Config.game_name,
                        paytable: Config.paytable,
                        paylines: Config.paylines,
                        reels_width: Config.reels_width,
                        reels_height: Config.reels_height,
                        percent: Config.percent,
                        version: Config.version,
                        title: Config.title,
                        iteration: Config.iteration,
                        version_settings: Config.version_settings,
                    };
                },
                computed: {
                    groupedWinnings() {
                        return _.groupBy(this.paytable, 'symbol');
                    }
                },
                methods: {
                    getWin(multiplier) {
                        return this.$store.state.currentAmount.amount * multiplier;
                    },

                    getWinOfTable(multiplier) {
                        return this.$store.state.currentAmount.amount * this.$store.state.currentPayline * multiplier;
                    },

                    thereIsMoneyWinnings(winnings) {
                        if (winnings.some(e => e.multiplier > 0)) {
                            return true;
                        }

                        return false;
                    }
                },
            });
        },
    },
}
</script>
